import { TCareConfigurationNotification } from '@/features/notifications/types/notification.type';

export const DEFAULT_GENERAL_CARE_NOTIFICATION = {
  overall: false,
  activeCaseSound: false,
  unassignedCaseSound: false,
  activeCount: 0,
};

export const DEFAULT_CARE_CONFIGURATION_NOTIFICATION: TCareConfigurationNotification = {
  config: {
    LABEL_CUSTOMER_ADDED: { app: false },
    LABEL_CHAT_ADDED: { app: false },
    LABEL_CASE_ADDED: { app: false },
    SLA_UPDATED: { app: false },
    CSAT_ENABLED: { app: false },
    CSAT_UPDATED: { app: false },
    TEAM_MEMBER_DELETED: { app: false, email: false },
    CSAT_DISABLED: { app: false },
    LABEL_CUSTOMER_DELETED: { app: false },
    LABEL_CHAT_DELETED: { app: false },
    LABEL_CASE_DELETED: { app: false },
    LABEL_CUSTOMER_UPDATED: { app: false },
    LABEL_CHAT_UPDATED: { app: false },
    LABEL_CASE_UPDATED: { app: false },
    TEAM_MEMBER_ASSIGNMENT: { app: false, email: false },
    NEW_CONVERSATION: { app: false },
    CHANNELS_AUTO_LABEL_UPDATED: { app: false },
    AUTO_LABEL_UPDATED: { app: false },
    NEW_TEAM_SUPERVISOR_ASSIGNMENT: { app: false },
    RESOLVED_CASE: { app: false, email: false },
    CHANNEL_ADDED: { app: false },
    CHANNEL_DELETED: { app: false },
    CLOSE_CONVERSATION: { app: false },
    CHANNEL_DISCONNECT: { app: false },
  },
  activeCount: 0,
};
